import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    Optional,
    Output,
    SimpleChanges
} from "@angular/core";
import {FUIAbstractControl} from "../framework/abstract-control";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIOptionsService} from "../framework/options.service";
import {FUISelectAction} from "../select-action";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIMultiselectControlComponent)
        },
        FUIOptionsService
    ],
    selector: "fui-multiselect-control",
    templateUrl: "./multiselect-control.component.html",
    standalone: false
})
export class FUIMultiselectControlComponent extends FUIAbstractControl implements OnChanges {
    @Input() public internallyFilterable: boolean;
    @Output() public filtered$: EventEmitter<string>;
    @Input() public labelField: string;
    @Input() public summaryLabelField: string;
    private _options: Array<any>;
    @Input() public total: number;
    @Input() public valueField: string;
    @Input() allowLabelMarkup: boolean = false;
    @Input() pillRemovable: boolean = true;
    @Input() showSelections: boolean = true;

    /**
     * Optional additional action buttons
     */
    @Input() public actions: FUISelectAction[];

    /**
     * Emitted when an action is clicked
     */
    @Output() public action$: EventEmitter<FUISelectAction>;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext,
                private optionsService: FUIOptionsService) {
        super(changeDetectorRef);
        this.internallyFilterable = true;
        this.filtered$ = new EventEmitter<string>();
        this.action$ = new EventEmitter<FUISelectAction>();
    }

    /**
     *
     * @returns {Array<any>}
     */
    get options(): Array<any> {
        return this._options;
    }

    /**
     *
     * @param {Array<any>} options
     */
    @Input()
    set options(options: Array<any>) {
        this._options = options;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["valueField"]) {
            this.optionsService.valueField = this.valueField;
        }
    }
}
